
import * as _ from "lodash";
export class FilterReqModel {
    climaticFilter;
    buildingFilter;
    assetFilter;
    energyFilter;
    categoryFilter;
    geoFilter;
    buildings;
    assets;
    concept;
    constructor(obj) {
        this.concept = _.filter(obj.concept, (json) => json.value.length > 0);
        this.climaticFilter = _.filter(obj.climaticFilter, (json) => json.value.length > 0);
        this.buildingFilter = _.filter(obj.buildingFilter, (json) => json.value.length > 0);
        this.assetFilter = _.filter(obj.assetFilter, (json) => json.value.length > 0);
        this.energyFilter = _.filter(obj.energyFilter, (json) => json.value.length > 0);
        this.categoryFilter = _.filter(obj.categoryFilter, (json) => json.value.length > 0);
        this.geoFilter = _.filter(obj.geoFilter, (json) => json.value.length > 0);
        // this.buildings = _.filter(obj.buildings, (json) => json.value.length > 0); 
        this.buildings = _.filter(obj.buildings, (json) => {
            if(json.hasOwnProperty('value')){
                if(Array.isArray(json['value'])){}
                else{
                    obj.buildings[0]['value'] = [obj.buildings[0]['value']]
                }
                if(json.value.length > 0){
                    return json;
                }
                else{
                    return [];
                }
            }
            else{
                return [];
            }
        });
        this.assets = _.filter(obj.assets, (asset) => asset.value.length > 0);
    }
}



